module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-page"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', {
    staticClass: "inner-page-wrap"
  }, [_c('Header'), (_vm.props.better_featured_image) ? _c('div', {
    staticClass: "banner_section",
    style: ({
      backgroundImage: 'url(' + _vm.props.better_featured_image.source_url + ')'
    })
  }, [_c('div', {
    staticClass: "banner_overlay"
  }), (_vm.props.title.rendered) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }) : _vm._e()]) : _vm._e(), _vm._l((_vm.props.acf.doctor_list), function(DocSingleList, index) {
    return (_vm.props.acf.doctor_list) ? _c('div', {
      staticClass: "doctorbio_outersection"
    }, [_c('div', {
      staticClass: "doctorbio_section"
    }, [_c('div', {
      staticClass: "anchor-link",
      attrs: {
        "id": "singledoc" + index
      }
    }), _c('div', {
      staticClass: "manual_container"
    }, [_c('div', {
      staticClass: "docbio_wrap clearfix"
    }, [_c('div', {
      staticClass: "docbio_img"
    }, [(DocSingleList.doc_img) ? _c('img', {
      attrs: {
        "src": DocSingleList.doc_img,
        "alt": ""
      }
    }) : _vm._e()]), _c('div', {
      staticClass: "docbio_content"
    }, [(DocSingleList.name) ? _c('h3', {
      domProps: {
        "innerHTML": _vm._s(DocSingleList.name)
      }
    }) : _vm._e(), (DocSingleList.designation) ? _c('h4', {
      domProps: {
        "innerHTML": _vm._s(DocSingleList.designation)
      }
    }) : _vm._e(), _c('div', {
      staticClass: "bio_p"
    }, [(DocSingleList.doc_intro) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(DocSingleList.doc_intro)
      }
    }) : _vm._e()])])])])]), _c('div', {
      staticClass: "docbio_moreinfo"
    }, [_c('div', {
      staticClass: "width800_wrap"
    }, [(DocSingleList.description) ? _c('div', {
      staticClass: "content_all",
      domProps: {
        "innerHTML": _vm._s(DocSingleList.description)
      }
    }) : _vm._e(), (DocSingleList.slider) ? _c('div', {
      staticClass: "doctorslider"
    }, [_c('swiper', {
      attrs: {
        "options": _vm.swiperOption1
      }
    }, [_vm._l((DocSingleList.slider), function(BeforeafterList) {
      return _c('swiper-slide', [(BeforeafterList.url) ? _c('img', {
        attrs: {
          "src": BeforeafterList.url
        }
      }) : _vm._e()])
    }), _c('div', {
      staticClass: "swiper-button-prev",
      attrs: {
        "slot": "button-prev"
      },
      slot: "button-prev"
    }), _c('div', {
      staticClass: "swiper-button-next",
      attrs: {
        "slot": "button-next"
      },
      slot: "button-next"
    })], 2)], 1) : _vm._e()])])]) : _vm._e()
  }), _c('div', {
    staticClass: "ourpromise_section"
  }, [_c('div', {
    staticClass: "anchor-link",
    attrs: {
      "id": "our-promise"
    }
  }), _c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.our_promise_content) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.our_promise_content)
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "technology_section"
  }, [_c('div', {
    attrs: {
      "id": "technology-and-research"
    }
  }, [(_vm.props.acf.technology_section_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.technology_section_title)
    }
  }) : _vm._e(), (_vm.props.acf.technology_video_src) ? _c('video', {
    attrs: {
      "controls": "controls",
      "poster": _vm.props.acf.technology_video_img
    }
  }, [(_vm.props.acf.technology_video_src) ? _c('source', {
    attrs: {
      "src": _vm.props.acf.technology_video_src,
      "type": "video/mp4"
    }
  }) : _vm._e()]) : _vm._e()])]), _c('div', {
    staticClass: "setsapart_section"
  }, [_c('div', {
    staticClass: "anchor-link",
    attrs: {
      "id": "what-sets-us-apart"
    }
  }), _c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.what_sets_us_apart_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.what_sets_us_apart_title)
    }
  }) : _vm._e(), (_vm.props.acf.what_sets_apart_list) ? _c('div', {
    staticClass: "differslider"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption2
    }
  }, [_vm._l((_vm.props.acf.what_sets_apart_list), function(DiffersliderList, j) {
    return _c('swiper-slide', {
      staticClass: "clearfix"
    }, [(DiffersliderList.right_img) ? _c('div', {
      staticClass: "differ_right",
      style: ({
        backgroundImage: 'url(' + DiffersliderList.right_img + ')'
      })
    }) : _vm._e(), (DiffersliderList.content) ? _c('div', {
      staticClass: "differ_left",
      domProps: {
        "innerHTML": _vm._s(DiffersliderList.content)
      }
    }) : _vm._e()])
  }), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2)], 1) : _vm._e()])]), _c('Footer')], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d68c2974","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/about-us/about-us.pug
// module id = 524
// module chunks = 1